// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"2632":"ff2f5689","8845":"19ac817d"}[chunkId] + ".chunk.css";
};